<template>
  <div class="mr-video">
    <div class="mask"><span class="player iconfont icon-pause" :class="{ 'icon-play': playType === 'icon-play', 'icon-pause': playType === 'icon-pause' }"></span></div>
    <img v-show="poster" :src="poster" alt="">
  </div>
</template>

<script>
  export default {
    name: 'Video',
    props: {
      src: { // 地址
        type: String
      },
      poster: { // 海报图
        type: String
      }
    },
    data() {
      return {
        playType: 'icon-play'
      }
    }
  }
</script>

<style lang="scss" scoped>
.mr-video{
  position: relative;
  min-height: 140px;
}
.mask{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  .player{
    display: block;
    font-size: 88px;
    color: #fff;
  }
}
video, img{
  object-fit: contain;
  width: inherit;
  height: 100%;
}
</style>
